export default "__VITE_ASSET__Cg7NQbIe__"